import { Component } from '@angular/core';
import { NavBlock } from '@shared/types';

@Component({
  selector: 'jb-secondary-nav-block-list-container',
  templateUrl: './secondary-nav-block-list-container.component.html',
  styleUrls: ['./secondary-nav-block-list-container.component.scss'],
})
export class SecondaryNavBlockListContainerComponent {
  navBlocks: Partial<NavBlock>[];
}

export const secondaryNavBlockListContainerResolver = (registry, data) => {
  return { navBlocks: data.secondaryBlock };
};
